import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.scss']
})
export class ErrorModalComponent implements OnInit {
  errorTitle: string = 'Error Occurred';
  errorMessage: string = '';

  constructor(
    public bsModalRef: BsModalRef,
    public translate: TranslateService
  ) {
    // Get errorMessage from initialState if available
    if ((this.bsModalRef as any).content) {
      const initialState = (this.bsModalRef as any).content;
      if (initialState.errorTitle) {
        this.errorTitle = initialState.errorTitle;
      }
      if (initialState.errorMessage) {
        this.errorMessage = initialState.errorMessage;
      }
    }
  }

  ngOnInit() {
    // Also check initialState from config
    const config = (this.bsModalRef as any).config;
    if (config && config.initialState) {
      if (config.initialState.errorTitle) {
        this.errorTitle = config.initialState.errorTitle;
      }
      if (config.initialState.errorMessage) {
        this.errorMessage = config.initialState.errorMessage;
      }
    }
  }

  close() {
    this.bsModalRef.hide();
  }
}

